import { Stack, styled } from "@mui/material";

interface ResponsiveStackProps {
  columnReverse?: boolean;
  rowReverse?: boolean;
}

export const ResponsiveStack = styled(Stack, {
  shouldForwardProp: (prop) => prop !== "columnReverse" && prop !== "rowReverse",
})<ResponsiveStackProps>(({ theme, columnReverse, rowReverse }) => ({
  flexDirection: columnReverse ? "column-reverse" : "column",
  [theme.breakpoints.up("sm")]: {
    flexDirection: rowReverse ? "row-reverse" : "row",
  },
}));
